<template>
  <div
    class="setting_main_contents"
    id="job-main-content"
  >
    <div :class="{'overlay_setting':isLoadingData}">
      <i :class="{'loadding_setting': isLoadingData}"></i>
    </div>
    <div class="setting_heading">
      <h1 class="setting_heading_title">
        {{ jobSettingProperty.TAB_HEADER }}
      </h1>
      <p class="setting_heading_explain">
        {{ jobSettingProperty.SUB_HEADER }}
      </p>
      <button class="setting_btn_outline" @click.prevent="openModalPreview">
        {{ jobSettingProperty.PREVIEW_BUTTON }}
      </button>
      <PreviewDisplay
        v-show="isVisibleModalPreview"
        :button="button"
        :categoriesSearchJob="jobSearchForm.categorySetting"
        :colors="searchColors"
        :masters="masters"
        :jobPageName="jobPageName"
        :jobOverview="jobOverview"
        @close="closeModalPreview"
        :numberOfJobDisplay="jobSearchForm.displaySetting.displayRecord"
        :headingSettings="headingSettings"
        :bodySettings="bodySettings"
        :categoriesJobList="jobListForm.categorySetting"
        :categoriesJobDetail="jobDetailForm.categorySetting"
        :commonSetting="commonSetting"
      />
    </div>
    <div class="setting_tab">
      <div class="setting_tab_nav">
        <ul class="setting_tab_nav_list">
          <li
            id="t6"
            class="setting_tab_nav_item is_active"
            @click.prevent="changeNavTab(BUTTON_TAB)"
          >
            <span class="setting_tab_nav_text">
              {{ jobSettingProperty.BUTTON_TAB_TITLE }}
            </span>
          </li>
          <li
            id="t7"
            class="setting_tab_nav_item"
            @click.prevent="changeNavTab(COLOR_THEME_TAB)"
          >
            <span class="setting_tab_nav_text">
              {{ jobSettingProperty.COLOR_THEME_TAB_TITLE }}
            </span>
          </li>
        </ul>
      </div>
      <div v-show="navTab === BUTTON_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <ButtonTab
            :button="button"
            :buttonError="buttonError"
            @updatedButtonError="updatedButtonError"
            :displaySettingJobList="jobListForm.displaySetting"
            :displaySettingJobDetail="jobDetailForm.displaySetting"
          />
        </div>
      </div>
      <div v-show="navTab === COLOR_THEME_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <CustomizeMode
            :categoriesSearchJob="jobSearchForm.categorySetting"
            :colors="searchColors"
            :masters="masters"
            :button="button"
            :groupName="groupName"
            :selectedTheme="selectedTheme"
            :searchCustomizeSettings="searchCustomizeSettings"
            :detailCustomizeSettings="detailCustomizeSettings"
            :jobPageName="jobPageName"
            :jobOverview="jobOverview"
            :userId="log.info.userId"
            :token="token"
            @updateCustomizeColors="updateCustomizeColors"
            @updatedSelectedTheme="updatedSelectedTheme"
            @refreshCustomizeSetting="refreshCustomizeSettings($event)"
            @createLogger="createLogger($event)"
            @sendLogger="sendLogger"
            :numberOfJobDisplay="jobSearchForm.displaySetting.displayRecord"
            :headingSettings="headingSettings"
            :bodySettings="bodySettings"
            :categoriesJobList="jobListForm.categorySetting"
            :categoriesJobDetail="jobDetailForm.categorySetting"
            :commonSetting="commonSetting"
          />
        </div>
      </div>
    </div>
    <div class="setting_footer" id="setting_footer">
      <button
        class="setting_btn_outline"
        @click="cancelChangeJobDataSetting()"
      >
        {{ jobSettingProperty.CANCEL_BUTTON }}
      </button>
      <button
        class="setting_btn_primary"
        @click="saveData()"
        :class="{
          'setting_btn_disabled': isDisableSaveBtn,
        }"
      >
        {{ jobSettingProperty.SAVE_BUTTON }}
      </button>
      <div class="setting_footer_balloon" v-if="unSavedData">
        {{ jobSettingNotifyProperty.SAVE_CHANGE_DATA }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ButtonTab from "./ButtonAndThemeSettingsComponents/ButtonTab.vue";
import CustomizeMode from "./ButtonAndThemeSettingsComponents/CustomizeMode.vue";
import PreviewDisplay from "./ButtonAndThemeSettingsComponents/PreviewDisplay";
import VueToast from "vue-toast-notification";
import masterSettingService from "../../../services/MasterSettingsService";
import formSettingService from "../../../services/FormSettingService";
import jobSettingService from "../../../services/JobSettingService";
import jobSettingProperty from "../../../properties/job_screen/job-screen.json";
import jobSettingNotifyProperty from "../../../properties/job_screen/job-notifications.json";
import entrySettingNotificationProperty from "../../../properties/entry_screen/notifications.json";
import * as generalLabels from "../../../properties/general_page/generalpage-labels.json";
import * as generalMessages from "../../../properties/general_page/generalpage.json";
import generalService from "../../../services/GeneralService";
import * as labelCustomizeModal from "../../../properties/job_screen/customize_tab/popup-customize/popup-customize-labels.json";
import dispatchJobSettingService from "../../../services/DispatchJobSettingService";
Vue.use(VueToast);

const JOB_SEARCH_FORM_TYPE = 1;
const JOB_DETAIL_FORM_TYPE = 2;
const JOB_LIST_FORM_TYPE = 4;
const DISPATCH_JOB_SEARCH_FORM_TYPE = 5;
const DISPATCH_JOB_DETAIL_FORM_TYPE = 6;
const DISPATCH_JOB_LIST_FORM_TYPE = 7;

const HEADING_SETTING_TYPE = 0;
const BODY_SETTING_TYPE = 1;
const SEARCH_BUTTON_TYPE = 0;
const LIST_BUTTON_TYPE = 1;
const DETAIL_BUTTON_TYPE = 2;
const CONTACT_BUTTON_TYPE = 3;

const BUTTON_TAB = 6;
const COLOR_THEME_TAB = 7;
const START_PAGE_TITLE = generalLabels.START_TITLE_PAGE + " > " + jobSettingProperty.JOB_PAGE_TITLE + " > ";

export default {
  name: "ButtonAndThemeSettings",
  props: ["groupName", "jobPageName", "jobOverview", "unSavedData", "userId", "token","commonSetting"],
  components: {
    ButtonTab,
    CustomizeMode,
    PreviewDisplay,
  },
  data: function () {
    return {
      isVisibleModalPreview: false,
      jobListForm:{
        categorySetting: [],
        buttonSetting: [],
        displaySetting: {}
      },
      jobDetailForm: {
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
        displaySetting: {}
      },
      jobSearchForm: {
        displaySetting: {
          displayRecord: 50,
          companyPublicSetting: "",
          homepagePostingSetting: "",
          companyPublicSettings: [],
          homepagePostingSettings: [],
        },
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      dispatchJobDetailForm: {
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      dispatchJobListForm: {
        categorySetting: [],
        buttonSetting: []
      },
      dispatchJobSearchForm: {
        displaySetting: {
          displayRecord: 50,
          companyPublicSetting: "",
          homepagePostingSetting: "",
          companyPublicSettings: [],
          homepagePostingSettings: [],
        },
        categorySetting: [],
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      },
      bodySettings: [],
      headingSettings: [],
      button: {
        searchBtn: "",
        listBtn: "",
        detailBtn: "",
        contactBtn: ""
      },
      buttonError: false,
      masters: [],
      searchColors: {
        themeName: "Default",
        borderColor: "#989090",
        keyColor: "#CFC9C9",
        linkText: "#3090D9",
        mainButtonText: "#FFFFFF",
        mainButton: "#F36A07",
        pageBackground: "#FFFFFF",
        pageText: "#0D0D0D",
        subButton: "#F8F7F7",
        subButtonText: "#000000",
        subColor: "#E7E4E4",
      },
      detailColors: {},
      selectedTheme: -1,
      searchCustomizeSettings: [],
      detailCustomizeSettings: [],
      isChangeColor: false,
      jobSettingProperty: jobSettingProperty,
      jobSettingNotifyProperty: jobSettingNotifyProperty,
      navTab: BUTTON_TAB,
      keyMasters: [],
      log: {
        info: {},
      },
      isDisableSaveBtn: false,
      BUTTON_TAB: BUTTON_TAB,
      COLOR_THEME_TAB: COLOR_THEME_TAB,
      isLoadingData: true
    };
  },
  watch: {
    navTab() {
      this.checkDisableSaveBtn();
    },
    buttonError() {
      this.checkDisableSaveBtn();
    },
  },
  async created() {
    document.title = START_PAGE_TITLE + jobSettingProperty.SEARCH_ENTRY_TAB_TITLE;
    await this.createLogger("Load data " + generalLabels.THIRD_TAB);

    await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, this.log.hash);
    await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, this.log.hash);

    await this.getSearchFormData(JOB_SEARCH_FORM_TYPE, this.log.hash);
    await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
    await this.getListFormData(JOB_LIST_FORM_TYPE, this.log.hash);
    await this.getDispatchJobSearchFormData(DISPATCH_JOB_SEARCH_FORM_TYPE, this.log.hash);
    await this.getDispatchJobDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
    await this.getDispatchJobListFormData(DISPATCH_JOB_LIST_FORM_TYPE, this.log.hash);

    this.isLoadingData = false;
  },
  methods: {
    checkDisableSaveBtn() {
      this.isDisableSaveBtn = this.navTab === BUTTON_TAB && this.buttonError;
    },

    async changeNavTab(tab) {
      if (this.navTab === tab) {
        return;
      }

      switch (tab) {
        case BUTTON_TAB:
          document.title = START_PAGE_TITLE + jobSettingProperty.BUTTON_TAB_TITLE;
          await this.createLogger(
            "Menu " +
              generalLabels.THIRD_TAB +
              "-Click tab " +
              jobSettingProperty.BUTTON_TAB_TITLE
          );
          break;
        case COLOR_THEME_TAB:
          document.title = START_PAGE_TITLE + jobSettingProperty.COLOR_THEME_TAB_TITLE;
          await this.createLogger(
            "Menu " +
              generalLabels.THIRD_TAB +
              "-Click tab " +
              jobSettingProperty.COLOR_THEME_TAB_TITLE
          );
          this.getKeyMasterUsed();
          if (this.keyMasters.length > 0) {
            await this.getMastersByCategorySetting(
              this.keyMasters,
              this.log.hash
            );
          }
          break;
      }

      if(document.getElementById("t" + this.navTab) && document.getElementById("t" + tab)){
        document.getElementById("t" + this.navTab).classList.remove("is_active");
        document.getElementById("t" + tab).classList.add("is_active");
      }
      this.navTab = tab;
    },

    getKeyMasterUsed() {
      if (this.jobSearchForm.categorySetting.length <= 0) {
        return;
      }

      this.keyMasters = [];
      this.jobSearchForm.categorySetting.filter(category => category && !category.categoryDeleted && category.item.length > 0).forEach(category =>{
        category.item.filter((item) => item.resourceField && item.resourceField.length > 0 && !item.itemDeleted).forEach((item) => {
          item.resourceField.filter((resource) =>!resource.itemResourceDeleted && resource.master_name).forEach((resource) => {
            if (!this.keyMasters.some((key) => key === resource.master_name)) {
              this.keyMasters.push(resource.master_name);
            }
          });
        });
      });
    },

    async getMastersByCategorySetting(keys, hash) {
      await masterSettingService
        .getMastersByCategorySetting(keys, hash)
        .then((response) => {
          if (response && response.data != null) {
            this.masters = response.data;
          }
        })
        .catch((e) => {
          console.log(e);
          Vue.$toast.clear();
          Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE,
            {
              position: "bottom-right",
              duration: 3000,
            }
          );
        });
    },

    updatedSelectedTheme(selectedTheme) {
      this.$eventBus.$emit("unSaved", true);
      this.selectedTheme = Number(selectedTheme);
    },

    async getSearchFormData(type, hash) {
      await formSettingService
        .getFormSettingByType(type, hash)
        .then( async (response) => {
          if (!response || !response.data || !response.data.id) {
            return;
          }

          this.jobSearchForm = response.data;
          this.handleInputBtn();
          this.handleInputColor();
          this.handleInputBodySetting();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getDetailFormData(type, hash) {
      await formSettingService
        .getFormSettingByType(type, hash)
        .then((response) => {
          if (!response || !response.data || !response.data.id) {
            return;
          }

          this.jobDetailForm = response.data;
          this.handleInputDisplaySetting(type);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getListFormData(type, hash) {
      await formSettingService
        .getFormSettingByType(type, hash)
        .then((response) => {
          if (!response || !response.data || !response.data.id) {
            return;
          }

          this.jobListForm = response.data;
          this.handleInputDisplaySetting(type);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    handleInputDisplaySetting(type) {
      if (type === JOB_LIST_FORM_TYPE) {
        this.jobListForm.displaySetting.print = this.jobListForm.displaySetting.print ? this.jobListForm.displaySetting.print: false;
      } else {
        this.jobDetailForm.displaySetting.print = this.jobDetailForm.displaySetting.print ? this.jobDetailForm.displaySetting.print: false;
      }
    },

    async getDispatchJobSearchFormData(type, hash) {
      await formSettingService
          .getFormSettingByType(type, hash)
          .then( async (response) => {
            if (!response || !response.data || !response.data.id) {
              return;
            }

            this.dispatchJobSearchForm = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },

    async getDispatchJobDetailFormData(type, hash) {
      await formSettingService
          .getFormSettingByType(type, hash)
          .then((response) => {
            if (!response || !response.data || !response.data.id) {
              return;
            }

            this.dispatchJobDetailForm = response.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },

    async getDispatchJobListFormData(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.dispatchJobListForm = response.data;
      }).catch(e => {
        console.log(e);
      });
    },

    handleInputBtn() {
      if(this.jobSearchForm.buttonSetting.length <= 0 ){
        this.button = {};
        return;
      }
      this.jobSearchForm.buttonSetting.forEach((btn) => {
        switch (btn.buttonType) {
          case SEARCH_BUTTON_TYPE: {
            this.button.searchBtn = btn.buttonName ? btn.buttonName : "";
            break;
          }
          case LIST_BUTTON_TYPE: {
            this.button.listBtn = btn.buttonName ? btn.buttonName : "";
            break;
          }
          case DETAIL_BUTTON_TYPE: {
            this.button.detailBtn = btn.buttonName ? btn.buttonName : "";
            break;
          }
          case CONTACT_BUTTON_TYPE: {
            this.button.contactBtn = btn.buttonName ? btn.buttonName : "";
            break;
          }
        }
      });
    },

    handleInputColor() {
      this.selectedTheme = this.jobSearchForm.formColorTheme;
      const index = this.searchCustomizeSettings.findIndex(
        (item) => item.id === this.selectedTheme
      );
      if (index === -1) {
        this.selectedTheme = this.searchCustomizeSettings[0].id;
        this.searchColors.themeName = this.searchCustomizeSettings[0].themeName;
        this.searchColors.borderColor =
          this.searchCustomizeSettings[0].borderColor;
        this.searchColors.keyColor = this.searchCustomizeSettings[0].keyColor;
        this.searchColors.linkText = this.searchCustomizeSettings[0].linkText;
        this.searchColors.mainButtonText =
          this.searchCustomizeSettings[0].mainButtonText;
        this.searchColors.mainButton =
          this.searchCustomizeSettings[0].mainButton;
        this.searchColors.pageBackground =
          this.searchCustomizeSettings[0].pageBackground;
        this.searchColors.pageText = this.searchCustomizeSettings[0].pageText;
        this.searchColors.subButton = this.searchCustomizeSettings[0].subButton;
        this.searchColors.subButtonText =
          this.searchCustomizeSettings[0].subButtonText;
        this.searchColors.subColor = this.searchCustomizeSettings[0].subColor;
      } else {
        this.searchColors.themeName =
          this.searchCustomizeSettings[index].themeName;
        this.searchColors.borderColor =
          this.searchCustomizeSettings[index].borderColor;
        this.searchColors.keyColor =
          this.searchCustomizeSettings[index].keyColor;
        this.searchColors.linkText =
          this.searchCustomizeSettings[index].linkText;
        this.searchColors.mainButtonText =
          this.searchCustomizeSettings[index].mainButtonText;
        this.searchColors.mainButton =
          this.searchCustomizeSettings[index].mainButton;
        this.searchColors.pageBackground =
          this.searchCustomizeSettings[index].pageBackground;
        this.searchColors.pageText =
          this.searchCustomizeSettings[index].pageText;
        this.searchColors.subButton =
          this.searchCustomizeSettings[index].subButton;
        this.searchColors.subButtonText =
          this.searchCustomizeSettings[index].subButtonText;
        this.searchColors.subColor =
          this.searchCustomizeSettings[index].subColor;
      }
    },

    handleInputBodySetting() {
      this.headingSettings = [];
      this.bodySettings = [];
      this.jobSearchForm.bodyHeadingSetting.forEach((setting) => {
        switch (setting.type) {
          case HEADING_SETTING_TYPE: {
            this.headingSettings.push(setting);
            break;
          }
          case BODY_SETTING_TYPE: {
            this.bodySettings.push(setting);
            break;
          }
        }
      });
    },

    handleOutputBtn(buttonSetting) {
      const searchBtnIndex = buttonSetting.findIndex(
        (btn) => btn.buttonType === SEARCH_BUTTON_TYPE
      );
      if (searchBtnIndex === -1) {
        buttonSetting.push({
          buttonName: this.button.searchBtn ? this.button.searchBtn : "",
          buttonType: SEARCH_BUTTON_TYPE,
        });
      } else {
        buttonSetting[searchBtnIndex].buttonName = this.button.searchBtn;
      }

      const listBtnIndex = buttonSetting.findIndex(
        (btn) => btn.buttonType === LIST_BUTTON_TYPE
      );
      if (listBtnIndex === -1) {
        buttonSetting.push({
          buttonName: this.button.listBtn ? this.button.listBtn : "",
          buttonType: LIST_BUTTON_TYPE,
        });
      } else {
        buttonSetting[listBtnIndex].buttonName = this.button.listBtn;
      }

      const detailBtnIndex = buttonSetting.findIndex(
        (btn) => btn.buttonType === DETAIL_BUTTON_TYPE
      );
      if (detailBtnIndex === -1) {
        buttonSetting.push({
          buttonName: this.button.detailBtn ? this.button.detailBtn : "",
          buttonType: DETAIL_BUTTON_TYPE,
        });
      } else {
        buttonSetting[detailBtnIndex].buttonName = this.button.detailBtn;
      }

      const contactBtnIndex = buttonSetting.findIndex(
        (btn) => btn.buttonType === CONTACT_BUTTON_TYPE
      );
      if (contactBtnIndex === -1) {
        buttonSetting.push({
          buttonName: this.button.contactBtn ? this.button.contactBtn : "",
          buttonType: CONTACT_BUTTON_TYPE,
        });
      } else {
        buttonSetting[contactBtnIndex].buttonName = this.button.contactBtn;
      }
    },

    handleOutputColors() {
      if (this.isChangeColor) {
        this.jobSearchForm.customizeSetting = this.searchColors;
        this.jobDetailForm.customizeSetting = this.detailColors;
      } else {
        if (this.selectedTheme === -1) {
          this.jobSearchForm.customizeSetting = this.searchColors;
          this.jobDetailForm.customizeSetting = this.searchColors;
        } else {
          const index = this.searchCustomizeSettings.findIndex(
            (item) => item.id === this.selectedTheme
          );
          if (index === -1) {
            this.jobSearchForm.customizeSetting = this.searchColors;
            this.jobDetailForm.customizeSetting = this.searchColors;
          } else {
            this.jobSearchForm.customizeSetting =
              this.searchCustomizeSettings[index];
            this.jobDetailForm.customizeSetting =
              this.detailCustomizeSettings[index];
          }
        }
      }
    },

    handleOutPutItemSetting(formData) {
      if (!formData.categorySetting || formData.categorySetting.length <= 0) {
        return;
      }

      formData.categorySetting.filter(category => category && category.item && category.item.length > 0).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter((resource) => resource).forEach(resource => {
            delete resource.default_value;
            if (resource.display_name && resource.display_name.length > 255) {
              resource.display_name = resource.display_name.substring(0, 255);
            }
          });
        });
      })
    },

    handleOutputData() {
      if (!this.buttonError) {
        this.handleOutputBtn(this.jobSearchForm.buttonSetting);
        this.handleOutputBtn(this.jobDetailForm.buttonSetting);
        this.handleOutputBtn(this.jobListForm.buttonSetting);
      }
      this.handleOutputColors();
      this.handleOutPutItemSetting(this.jobSearchForm);
      this.handleOutPutItemSetting(this.jobDetailForm);
      this.handleOutPutItemSetting(this.jobListForm);
    },

    async saveData() {
      this.isLoadingData = true;
      Vue.$toast.clear();
      this.handleOutputData();
      this.log.info.paras = {
        jobSearchForm: this.jobSearchForm,
        jobDetailForm: this.jobDetailForm,
        jobListForm: this.jobListForm
      };

      await this.createLogger(
          "Menu " +
          generalLabels.THIRD_TAB +
          "-Click button " +
          jobSettingProperty.SAVE_BUTTON
      );

      Promise.all([
        formSettingService.saveJobSearchForm(
          this.jobSearchForm,
          this.log.hash,
          this.token
        ),
        formSettingService.saveJobDetailForm(
          this.jobDetailForm,
          this.log.hash,
          this.token
        ),
        formSettingService.saveJobListForm(
          this.jobListForm,
          this.log.hash,
          this.token
        ),
        dispatchJobSettingService.saveDispatchJobSearchForm(this.dispatchJobSearchForm, this.log.hash, this.token),
        dispatchJobSettingService.saveDispatchJobDetailForm(this.dispatchJobDetailForm, this.log.hash, this.token),
        dispatchJobSettingService.saveDispatchJobListForm(this.dispatchJobListForm, this.log.hash, this.token)
      ])
        .then(async() => {
          Vue.$toast.success(
            entrySettingNotificationProperty.SAVE_SUCCESSFUL,
            {
              position: "bottom-right",
              duration: 3000,
            }
          );

          await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, this.log.hash);
          await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, this.log.hash);
          await this.getSearchFormData(JOB_SEARCH_FORM_TYPE, this.log.hash);
          await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
          await this.getListFormData(JOB_LIST_FORM_TYPE, this.log.hash);
          await this.getDispatchJobSearchFormData(DISPATCH_JOB_SEARCH_FORM_TYPE, this.log.hash);
          await this.getDispatchJobDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
          await this.getDispatchJobListFormData(DISPATCH_JOB_LIST_FORM_TYPE, this.log.hash);
          this.isChangeColor = false;
          this.$eventBus.$emit("unSaved", false);
        })
        .catch((e) => {
          console.log(e);
          if (e.response.data === 'Form has been already updated!') {
            Vue.$toast.error(generalMessages.ERROR_FORM_HAS_BEEN_UPDATED, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          } else {
            Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          }
        }).finally(() => {
          this.isLoadingData = false;
        });
      delete this.log.info.paras;
    },

    async cancelChangeJobDataSetting() {
      this.isLoadingData = true;
      await this.createLogger(
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Click button " +
          jobSettingProperty.CANCEL_BUTTON
      );
      await this.getSearchFormData(JOB_SEARCH_FORM_TYPE, this.log.hash);
      await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
      await this.getListFormData(JOB_LIST_FORM_TYPE, this.log.hash);
      await this.getDispatchJobSearchFormData(DISPATCH_JOB_SEARCH_FORM_TYPE, this.log.hash);
      await this.getDispatchJobDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
      await this.getDispatchJobListFormData(DISPATCH_JOB_LIST_FORM_TYPE, this.log.hash);

      await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, this.log.hash);
      await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, this.log.hash);

      if(!this.jobSearchForm.id || !this.jobDetailForm.id){
        this.resetDataSetting();
      }
      this.$eventBus.$emit("unSaved", false);
      this.isLoadingData = false;
    },

    resetDataSetting(){
      this.jobSearchForm = {
        buttonSetting: [],
        bodyHeadingSetting: [],
        customizeSetting: {},
      }
      this.jobDetailForm = {
        buttonSetting: [],
        customizeSetting: {},
      }
      this.button = {};
      this.buttonError = false;
      this.selectedTheme = 1;
    },

    async getJobSearchCustomizes(type, hash) {
      await jobSettingService
        .getCustomizeTheme(type, hash, this.token)
        .then((response) => {
          this.searchCustomizeSettings = response.data;
          if (
            this.searchCustomizeSettings.length !== 0 &&
            this.selectedTheme === -1
          ) {
            this.selectedTheme = this.searchCustomizeSettings[0].id;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getJobDetailCustomizes(type, hash) {
      await jobSettingService
        .getCustomizeTheme(type, hash, this.token)
        .then((response) => {
          this.detailCustomizeSettings = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    closeModalPreview() {
      this.createLogger(
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Click button " +
          labelCustomizeModal.BUTTON_CLOSE_MODAL
      );
      this.isVisibleModalPreview = false;
    },

    async openModalPreview() {
      this.isLoadingData = true;
      if(this.selectedTheme > 0){
        this.searchColors = this.searchCustomizeSettings.find(customizeColor => customizeColor && customizeColor.id === this.selectedTheme);
      }
      await this.createLogger(
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Click button " +
          jobSettingProperty.PREVIEW_BUTTON
      );
      this.getKeyMasterUsed();
      if (this.keyMasters.length > 0) {
        await this.getMastersByCategorySetting(this.keyMasters, this.log.hash);
      }
      this.isVisibleModalPreview = true;
      this.isLoadingData = false;
    },

    updatedButtonError(val) {
      this.buttonError = Boolean(val);
    },

    updateCustomizeColors(searchColors, detailColors, isChange) {
      if (isChange !== undefined) {
        this.isChangeColor = isChange;
      }

      this.searchColors = JSON.parse(JSON.stringify(searchColors));
      this.detailColors = JSON.parse(JSON.stringify(detailColors));
    },

    async refreshCustomizeSettings(hash) {
      await this.getJobSearchCustomizes(JOB_SEARCH_FORM_TYPE, hash);
      await this.getJobDetailCustomizes(JOB_DETAIL_FORM_TYPE, hash);
      const indexOfThemeSetting = this.searchCustomizeSettings.findIndex(customizeSetting => customizeSetting.id === this.jobSearchForm.formColorTheme);
      if (indexOfThemeSetting === -1) {
        this.selectedTheme = this.searchCustomizeSettings[0].id;
        this.$eventBus.$emit("unSaved", true);
      } else {
        this.selectedTheme = this.jobSearchForm.formColorTheme;
        this.$eventBus.$emit("unSaved", false);
      }
    },

    async sendLogger(loggerData) {
      this.logs = loggerData;
      await generalService
        .sendLogger(this.logs.hash, this.logs.info.path, this.logs)
        .then((response) => {
          if (response.status === 200) {
            return true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async createLogger(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.sendLogger(this.log);
    },
  },
};
</script>
<style lang="css" scoped>
.setting_heading{
  height: 28.8px;
}
</style>
